// English -> Finnish dictionary. Keys are trimmed text node contents.
// Add entries any time — they are matched at runtime by the i18n provider.
export const translations: Record<"FI", Record<string, string>> = {
  FI: {
    // ---------- Header / Nav ----------
    "Home": "Etusivu",
    "Menu": "Menu",
    "Locations": "Sijainnit",
    "Franchise": "Franchising",
    "Shop": "Kauppa",
    "Order Now": "Tilaa nyt",
    "Order": "Tilaa",
    "Spots": "Paikat",
    "Language: English": "Kieli: Suomi",
    "Language: Suomi": "Kieli: Suomi",

    // ---------- Footer ----------
    "The new generation of Nordic street food. Born from the streets of Helsinki.\n            Powered by community. Built to scale.":
      "Pohjoismaisen katuruoan uusi sukupolvi. Syntynyt Helsingin kaduilla. Yhteisön voimalla. Rakennettu skaalautumaan.",
    "Explore": "Tutustu",
    "Contact": "Yhteystiedot",
    "Modern Mexican Soul · Est. Hietalahti": "Modernia meksikolaista sielua · Est. Hietalahti",

    // ---------- Home / Hero ----------
    "Helsinki · Est. Hietalahti": "Helsinki · Est. Hietalahti",
    "The new generation of": "Pohjoismaisen",
    "Nordic street food": "katuruoan uusi sukupolvi",
    ". Slow-cooked birria, modern energy, viral momentum.":
      ". Hitaasti haudutettu birria, modernia energiaa, viraalia vauhtia.",
    "View Menu": "Katso menu",
    "Franchise With Us": "Ryhdy franchise-kumppaniksi",
    "Now serving": "Tarjoilemme nyt",
    "Kamppi · Lapinlahdenkatu": "Kamppi · Lapinlahdenkatu",

    // ---------- Born From Streets ----------
    "Born From The Streets": "Syntynyt kaduilla",
    "Origin Story": "Alkutarina",
    "BUILT BY THE": "RAKENNETTU",
    "COMMUNITY.": "YHTEISÖN VOIMIN.",
    "Founded": "Perustettu",
    "Nordic Birria": "Pohjoismainen Birria",
    "Word of mouth": "Suusta suuhun",
    "It started as a small taco kiosk at Hietalahti market. Long queues, organic hype,\n          and a community that showed up not just for tacos — but for the energy.\n          No big marketing budget. Just real flavor, person to person.":
      "Kaikki alkoi pienenä taco-kioskina Hietalahden torilla. Pitkät jonot, orgaaninen hype ja yhteisö, joka tuli paikalle ei vain tacojen — vaan energian — vuoksi. Ei suurta markkinointibudjettia. Vain aitoa makua, ihmiseltä ihmiselle.",
    "In September 2024 we opened our first brick-and-mortar in Kamppi, Helsinki —\n          and with it, the first birrieria in the Nordics.":
      "Syyskuussa 2024 avasimme ensimmäisen kivijalkamme Kampissa, Helsingissä — ja samalla Pohjoismaiden ensimmäisen birrieria-ravintolan.",
    "Still serving": "Yhä auki",
    "Helsinki · FI": "Helsinki · FI",
    "Where it began": "Mistä se alkoi",
    "Market Square Kiosk": "Torin kioski",
    "Hietalahti · HEL": "Hietalahti · HEL",

    // ---------- Birrieria ----------
    "Pohjoismaiden ensimmäinen": "Pohjoismaiden ensimmäinen",
    "THE ONLY": "AINOA",
    "BIRRIERIA": "BIRRIERIA",
    "IN FINLAND": "SUOMESSA",
    "Authentic Tijuana-style birria. Slow-cooked for hours. Dipped, sizzled, devoured.\n          A concept that doesn't exist anywhere else in the Nordics.":
      "Aitoa Tijuana-tyylistä birriaa. Haudutettu tunteja. Kastetaan, paistetaan, ahmitaan. Konsepti, jota ei ole missään muualla Pohjoismaissa.",
    "As featured in": "Esiintynyt mediassa",
    "Print + Online": "Printti + Online",
    "Best Tacos · Helsinki": "Helsingin parhaat tacot",
    "Award · 2024": "Palkinto · 2024",
    "Verified": "Vahvistettu",

    // Press card quotes
    "Helsingin kuumin uusi street food -ilmiö.": "Helsingin kuumin uusi street food -ilmiö.",
    "The most authentic birria in the city — hands down.":
      "Kaupungin aidoin birria — ehdottomasti.",
    "Authentic birria, slow-cooked, worth every minute of the queue.":
      "Aitoa birriaa, hitaasti haudutettu, jokaisen jonominuutin arvoinen.",
    "POV: you waited 40 min and it was worth every second.":
      "POV: jonotit 40 min ja se oli jokaisen sekunnin arvoinen.",
    "The dip shot that broke the algorithm.":
      "Dippauspläjäys, joka rikkoi algoritmin.",

    // Press meta
    "275 reviews": "275 arvostelua",
    "400K+ views": "400K+ katselua",
    "Trending · Reels": "Trendaava · Reels",

    // ---------- Viral ----------
    "Viral Momentum": "Viraalia vauhtia",
    "THE INTERNET": "INTERNET",
    "CAN'T STOP": "EI VOI LOPETTAA",
    "EATING.": "SYÖMISTÄ.",
    "Follow @tacoya →": "Seuraa @tacoya →",
    "Organic views": "Orgaaniset katselut",
    "Last 90 days": "Viimeiset 90 päivää",
    "TikTok engagement": "TikTok-sitoutuminen",
    "Likes & saves": "Tykkäykset & tallennukset",
    "Shares & comments": "Jaot & kommentit",
    "Across platforms": "Eri alustoilla",
    "Growing community": "Kasvava yhteisö",
    "Live": "Live",
    "best birria outside mexico fr": "paras birria meksikon ulkopuolella oikeesti",
    "this place is a movement": "tää paikka on liike",
    "queue was worth every minute": "jono oli jokaisen minuutin arvoinen",

    // ---------- BestSellers ----------
    "BEST": "MYYDYIMMÄT",
    "SELLERS": "SUOSIKIT",
    "Full menu": "Koko menu",
    "Best Seller": "Myydyin",
    "Cult Favorite": "Kulttisuosikki",
    "OG": "OG",
    "Quesabirria": "Quesabirria",
    "Birria Ramen": "Birria Ramen",
    "Birria Taco": "Birria Taco",
    "Crispy cheese-edge tortilla, slow-cooked beef, side of consommé.":
      "Rapeareunainen juustotortilla, hitaasti haudutettu naudanliha, kupillinen consomméa.",
    "Two cultures, one bowl. Rich birria broth, ramen noodles, shredded beef.":
      "Kaksi kulttuuria, yksi kulho. Täyteläinen birria-liemi, ramen-nuudelit, revittyä naudanlihaa.",
    "The one that started it all. Dipped, fried, devoured.":
      "Se, joka aloitti kaiken. Kastettu, paistettu, ahmittu.",

    // ---------- Marquee items ----------
    "FRANCHISE NOW": "RYHDY FRANCHISE-KUMPPANIKSI",
    "EXPAND THE MOVEMENT": "LAAJENNA LIIKETTÄ",
    "BRING TACOYA TO YOUR CITY": "TUO TACOYA OMAAN KAUPUNKIISI",

    // ---------- StreetFood ----------
    "Tacoya Street Food": "Tacoya Street Food",
    "SMALL FOOTPRINT.": "PIENI TILA.",
    "BIG ENERGY.": "ISO ENERGIA.",
    "Our next chapter: compact, high-energy Tacoya Street Food units built for\n            scale. Operationally simple, visually loud, and franchise-ready.":
      "Seuraava lukumme: kompaktit, korkean energian Tacoya Street Food -yksiköt, jotka on rakennettu skaalautumaan. Operatiivisesti yksinkertaisia, visuaalisesti äänekkäitä ja franchise-valmiita.",
    "Vaasankatu pilot — coming 2025": "Vaasankadun pilotti — tulossa 2025",
    "Nordic expansion in progress": "Pohjoismainen laajentuminen käynnissä",
    "Compact, high-throughput model": "Kompakti, suuren kapasiteetin malli",
    "TACOYA / STREET": "TACOYA / STREET",
    "Helsinki · Pilot Unit": "Helsinki · Pilottiyksikkö",
    "FRANCHISE READY": "FRANCHISE-VALMIS",

    // ---------- Retail ----------
    "Retail · Coming Soon": "Vähittäismyynti · Tulossa pian",
    "TASTE TACOYA": "MAISTA TACOYAA",
    "AT HOME.": "KOTONA.",
    "Our signature sauces, seasonings and bottled products are coming to Nordic supermarkets.\n            Built from the same recipes the queue lines up for.":
      "Tunnusmerkilliset kastikkeemme, mausteseoksemme ja pullotetut tuotteemme saapuvat pohjoismaisiin supermarketteihin. Rakennettu samoista resepteistä, joista jono nousee.",
    "Get notified": "Saa ilmoitus",
    "Chili Crunch": "Chili Crunch",
    "Smoked Salsa": "Savustettu Salsa",
    "Lime Verde": "Lime Verde",
    "Yellow Heat": "Keltainen Tuli",
    "Sauce · 200ml": "Kastike · 200ml",
    "Soon": "Pian",

    // ---------- Community ----------
    "Community": "Yhteisö",
    "THIS IS A": "TÄMÄ ON",
    "MOVEMENT.": "LIIKE.",

    // ---------- CTA ----------
    "Open Now · Until 22:00": "Auki nyt · 22:00 saakka",
    "4.6 · 275 reviews": "4.6 · 275 arvostelua",
    "Helsinki · Kamppi Flagship": "Helsinki · Kamppi-lippulaiva",
    "COME EAT": "TULE SYÖMÄÄN",
    "WITH": "KANSSAMME",
    "US.": ".",
    "Walk in, queue up, dip in. Authentic Tijuana-style birria — slow-cooked,\n              dipped and sizzled to order. Or bring Tacoya to your city.":
      "Astu sisään, jonota, kasta. Aitoa Tijuana-tyylistä birriaa — hitaasti haudutettu, kastettu ja paistettu tilauksesta. Tai tuo Tacoya omaan kaupunkiisi.",
    "Address": "Osoite",
    "Hours": "Aukioloajat",
    "Mon–Sat 11–22 · Sun 12–21": "Ma–La 11–22 · Su 12–21",
    "Find Us": "Löydä meidät",
    "Lapinlahdenkatu": "Lapinlahdenkatu",

    // ---------- Menu page ----------
    "The Menu": "Menu",
    "EAT": "SYÖ",
    "LIKE": "KUTEN",
    "THE STREETS.": "KADUT.",
    "Small menu. Big flavor. Every dish is built on slow-cooked birria and the\n          recipes that put us on the map.":
      "Pieni menu. Iso maku. Jokainen annos rakentuu hitaasti haudutetulle birrialle ja resepteille, jotka nostivat meidät kartalle.",
    "Birria — The Original": "Birria — Alkuperäinen",
    "The Fusion": "Fuusio",
    "Signature Sauces": "Tunnusmerkilliset kastikkeet",
    "Birria Plate": "Birria-lautanen",
    "Birria Burrito": "Birria Burrito",
    "Loaded Fries": "Täytetyt Ranskalaiset",
    "Salsa Verde": "Salsa Verde",
    "Crema": "Crema",
    "Hand-dipped tortilla, slow-cooked beef, white onion, cilantro. Served with consommé.":
      "Käsin kastettu tortilla, hitaasti haudutettu naudanliha, valkosipuli, korianteri. Tarjoillaan consommén kera.",
    "Crispy cheese-edge tortilla, melted Oaxaca-style cheese, shredded beef.":
      "Rapeareunainen juustotortilla, sulanut Oaxaca-tyylinen juusto, revitty naudanliha.",
    "Stewed beef, consommé bowl, rice, beans and four hand-pressed tortillas.":
      "Haudutettu naudanliha, consommé-kulho, riisi, pavut ja neljä käsin painettua tortillaa.",
    "Birria broth, ramen noodles, shredded beef, soft egg, chili oil.":
      "Birria-liemi, ramen-nuudelit, revitty naudanliha, pehmeä kananmuna, chiliöljy.",
    "Loaded with birria, rice, beans, cheese and salsa verde.":
      "Täytetty birrialla, riisillä, pavuilla, juustolla ja salsa verdellä.",
    "Crispy fries, birria, melted cheese, pickled jalapeños, crema.":
      "Rapeat ranskalaiset, birria, sulanut juusto, säilötyt jalapeñot, crema.",
    "Smoky, crunchy, dangerously good.": "Savuinen, rapea, vaarallisen hyvä.",
    "Roasted tomatillos, jalapeño, lime.": "Paahdetut tomatillot, jalapeño, lime.",
    "Cooling Mexican-style crema.": "Viilentävä meksikolaistyylinen crema.",
    "3 dishes": "3 annosta",

    // ---------- Locations page ----------
    "WHERE": "MISSÄ",
    "TO EAT.": "SYÖDÄ.",
    "Kamppi Flagship": "Kamppi-lippulaiva",
    "Vaasankatu — Street": "Vaasankatu — Street",
    "Birrieria": "Birrieria",
    "Street Food Unit": "Street Food -yksikkö",
    "Hip-hop · Reggaetón · Latin trap": "Hip-hop · Reggaetón · Latin trap",
    "Late-night street energy": "Myöhäisillan katuenergia",
    "Coming 2025": "Tulossa 2025",
    "OPEN": "AUKI",
    "SOON": "PIAN",
    "Open in Maps →": "Avaa kartalla →",
    "Walk-in welcome": "Walk-in tervetullut",
    "Notify Me": "Ilmoita minulle",
    "Opening soon": "Avataan pian",
    "Next stops": "Seuraavat pysäkit",
    "Tampere · Turku · Stockholm · Oslo": "Tampere · Turku · Tukholma · Oslo",
    "The expansion is happening. Want to bring Tacoya to your city?":
      "Laajentuminen on käynnissä. Haluatko tuoda Tacoyan omaan kaupunkiisi?",

    // ---------- Franchise page ----------
    "For investors · operators · partners": "Sijoittajille · operaattoreille · kumppaneille",
    "BRING TACOYA": "TUO TACOYA",
    "TO YOUR CITY.": "OMAAN KAUPUNKIISI.",
    "Small footprint. Big brand. Viral product. Operationally simple.\n          Tacoya is built to scale across the Nordics — and beyond.":
      "Pieni tila. Iso brändi. Viraali tuote. Operatiivisesti yksinkertainen. Tacoya on rakennettu skaalautumaan Pohjoismaissa — ja sen ulkopuolella.",
    "Start the conversation": "Aloita keskustelu",
    "WHY": "MIKSI",
    "TACOYA.": "TACOYA.",
    "Compact Format": "Kompakti formaatti",
    "High-throughput units that fit anywhere — kiosks, food halls, high streets.":
      "Suuren kapasiteetin yksiköt, jotka mahtuvat minne tahansa — kioskit, ruokahallit, kauppakadut.",
    "Viral Demand": "Viraali kysyntä",
    "Hundreds of thousands of organic views. A brand the internet already loves.":
      "Satoja tuhansia orgaanisia katseluita. Brändi, jota internet jo rakastaa.",
    "Simple Ops": "Yksinkertainen operointi",
    "Tight menu, slow-cook system, repeatable execution. Built by operators, for operators.":
      "Tiivis menu, hidas haudutusjärjestelmä, toistettava toteutus. Operaattorien rakentama, operaattoreille.",
    "Nordic Vision": "Pohjoismainen visio",
    "First-mover in birria across the Nordics. International scale on the roadmap.":
      "Birria-pioneeri Pohjoismaissa. Kansainvälinen skaala etenemissuunnitelmassa.",
    "Roadmap": "Etenemissuunnitelma",
    "THE EXPANSION.": "LAAJENTUMINEN.",
    "Hietalahti Origins": "Hietalahden alku",
    "Tacoya is born as a market kiosk. The queue forms.":
      "Tacoya syntyy torikioskina. Jono muodostuu.",
    "First brick-and-mortar opens. Pohjoismaiden ensimmäinen birrieria.":
      "Ensimmäinen kivijalka avautuu. Pohjoismaiden ensimmäinen birrieria.",
    "Street Food Units": "Street Food -yksiköt",
    "Compact Tacoya Street units roll out across Helsinki.":
      "Kompaktit Tacoya Street -yksiköt avautuvat Helsingissä.",
    "Nordic Expansion": "Pohjoismainen laajentuminen",
    "Franchise partners across Finland, Sweden, Norway.":
      "Franchise-kumppaneita Suomessa, Ruotsissa ja Norjassa.",
    "Retail & Beyond": "Vähittäismyynti ja sen jälkeen",
    "FMCG sauces, supermarket distribution, international scale.":
      "FMCG-kastikkeet, supermarket-jakelu, kansainvälinen skaala.",
    "Apply": "Hae",
    "TELL US ABOUT": "KERRO MEILLE",
    "YOUR CITY.": "KAUPUNGISTASI.",
    "Message received.": "Viesti vastaanotettu.",
    "We'll be in touch within a few days. Get ready.":
      "Olemme yhteydessä muutaman päivän sisällä. Valmistaudu.",
    "Your name": "Nimesi",
    "Email": "Sähköposti",
    "Target city": "Kohdekaupunki",
    "Tell us about your background": "Kerro taustastasi",
    "Submit application": "Lähetä hakemus",
    "Required": "Pakollinen",
    "Invalid email": "Virheellinen sähköposti",
    "Tell us a bit more": "Kerro hieman lisää",

    // ---------- Shop page ----------
    "Drop 001 · Loading": "Drop 001 · Latautuu",
    "Early access open": "Aikainen pääsy avoinna",
    "The first Tacoya drop. Sauces bottled from our kitchen.\n            Spice blends used behind our line. Apparel built like the food —\n            heavy, honest, made to last. Limited first run.":
      "Ensimmäinen Tacoya-drop. Keittiöstämme pullotetut kastikkeet. Linjamme takana käytetyt mausteseokset. Vaatteet rakennettu kuten ruoka — painavia, rehellisiä, kestämään tehtyjä. Rajoitettu ensimmäinen erä.",
    "Days": "Päivää",
    "Minutes": "Minuuttia",
    "Seconds": "Sekuntia",
    "DROP 001": "DROP 001",
    "BOTTLED IN HELSINKI": "PULLOTETTU HELSINGISSÄ",
    "LIMITED RUN": "RAJOITETTU ERÄ",
    "FREE SHIPPING > 60€": "ILMAINEN TOIMITUS > 60€",
    "SHIPS TO EU": "TOIMITUS EU:HUN",
    "Drop hero": "Drop-sankari",
    "CHILI CRUNCH No.1": "CHILI CRUNCH No.1",
    "The bottle that started the queue.": "Pullo, joka aloitti jonon.",
    "Hero": "Sankari",
    "Heat 3/3": "Tulisuus 3/3",
    "Sauce · Limited": "Kastike · Rajoitettu",
    "Toasted chiles. Garlic. Sesame. Slow oil.":
      "Paahdetut chilit. Valkosipuli. Seesami. Hidas öljy.",
    "Built behind the line over two years. Crunchy, smoky, balanced — not just hot.\n              Spoon it on tacos, eggs, ramen, anything. The bottle people kept asking us to sell.":
      "Rakennettu linjan takana kahden vuoden ajan. Rapea, savuinen, tasapainoinen — ei vain tulinen. Lusikoi tacoihin, kananmuniin, rameniin, mihin tahansa. Pullo, jota ihmiset pyysivät myyntiin.",
    "Single-origin morita & guajillo": "Single-origin morita & guajillo",
    "Cold-pressed sunflower oil": "Kylmäpuristettu auringonkukkaöljy",
    "Bottled in Helsinki, by hand": "Pullotettu Helsingissä käsin",
    "Drop price · 1500 bottles": "Drop-hinta · 1500 pulloa",
    "Drops Soon": "Saapuu pian",
    "The drop": "Drop",
    "ALL PIECES": "KAIKKI TUOTTEET",
    "All": "Kaikki",
    "Sauce": "Kastike",
    "Spice": "Mauste",
    "Apparel": "Vaatteet",
    "Signature": "Tunnusmerkki",
    "Limited": "Rajoitettu",
    "Drop": "Drop",
    "Notify": "Ilmoita",
    "Chili Crunch No.1": "Chili Crunch No.1",
    "Salsa Verde Cruda": "Salsa Verde Cruda",
    "Smoked Morita": "Savustettu Morita",
    "Tacoya Seasoning": "Tacoya-mauste",
    "Birria Spice Mix": "Birria-mausteseos",
    "Logo Tee — Black": "Logo-paita — Musta",
    "Hietalahti Hoodie": "Hietalahti-huppari",
    "Tomatillo, jalapeño, cilantro. Bright and loud.":
      "Tomatillo, jalapeño, korianteri. Kirkas ja äänekäs.",
    "Habanero, mustard, lime. The Tacoya yellow.":
      "Habanero, sinappi, lime. Tacoyan keltainen.",
    "Slow-smoked morita chiles. Deep, almost sweet.":
      "Hitaasti savustetut morita-chilit. Syvä, melkein makea.",
    "House blend. The one we use behind the line.":
      "Talon sekoitus. Sama jota käytämme linjan takana.",
    "Make our birria at home. 4-portion pack.":
      "Tee birriamme kotona. 4 hengen pakkaus.",
    "Heavy 240gsm cotton. Front mark, back wordmark.":
      "Painava 240gsm puuvilla. Etumerkki, takana sanamerkki.",
    "Tribute to where it started. 400gsm fleece.":
      "Kunnianosoitus alkupisteelle. 400gsm fleece.",
    "Lookbook 001": "Lookbook 001",
    "FOOD. STREET. UNIFORM.": "RUOKA. KATU. UNIFORMU.",
    "EU shipping": "EU-toimitus",
    "From Helsinki. 2–5 days across Nordics & EU.":
      "Helsingistä. 2–5 päivää Pohjoismaihin & EU:hun.",
    "30-day return": "30 päivän palautus",
    "Sealed bottles only. Apparel unworn.":
      "Vain avaamattomat pullot. Vaatteet käyttämättömiä.",
    "Drop guarantee": "Drop-takuu",
    "Numbered batches. No restocks of Drop 001.":
      "Numeroidut erät. Ei täydennyksiä Drop 001:lle.",
    "Built by chefs": "Kokkien rakentama",
    "Recipes from the actual Tacoya kitchen line.":
      "Reseptit suoraan Tacoyan keittiöltä.",
    "FAQ": "UKK",
    "THE BASICS": "PERUSASIAT",
    "When does Drop 001 go live?": "Milloin Drop 001 julkaistaan?",
    "Two weeks from today, 18:00 CET. Early-access emails get a 24-hour head start.":
      "Kaksi viikkoa tästä, 18:00 CET. Aikaisen pääsyn sähköpostit saavat 24 tunnin etumatkan.",
    "Will there be restocks?": "Tuleeko täydennyksiä?",
    "No. Drop 001 is a single, numbered run. Future drops are reworked, not reprinted.":
      "Ei. Drop 001 on yksittäinen, numeroitu erä. Tulevat dropit ovat uudistettuja, ei uusintapainoksia.",
    "Where do you ship?": "Mihin toimitatte?",
    "All EU. Nordics 2–3 days, rest of EU 3–5 days. UK and US coming with Drop 002.":
      "Koko EU. Pohjoismaat 2–3 päivää, muu EU 3–5 päivää. UK ja USA tulevat Drop 002:n mukana.",
    "Are the sauces shelf-stable?": "Ovatko kastikkeet säilyviä?",
    "Yes. Sealed bottles last 12 months unopened, 3 months chilled after opening.":
      "Kyllä. Avaamattomat pullot säilyvät 12 kuukautta, avaamisen jälkeen 3 kuukautta kylmässä.",
    "Early access": "Aikainen pääsy",
    "GET FIRST": "OLE",
    "DIBS.": "ENSIMMÄINEN.",
    "24-hour head start. Drop alerts. Behind-the-line stories.":
      "24 tunnin etumatka. Drop-ilmoitukset. Tarinat linjan takaa.",
    "No spam, ever.": "Ei roskapostia, koskaan.",
    "2.4k members": "2,4k jäsentä",
    "Avg 1 email / drop": "Keskim. 1 sähköposti / drop",
    "You're on the list.": "Olet listalla.",
    "Check your inbox — we'll ping you 24 hours before public drop.":
      "Tarkista sähköpostisi — ilmoitamme 24 tuntia ennen julkista dropia.",
    "Notify me →": "Ilmoita minulle →",
    "By signing up you agree to occasional drop emails.":
      "Rekisteröitymällä hyväksyt satunnaiset drop-sähköpostit.",
    "Menu →": "Menu →",
    "Locations →": "Sijainnit →",
    "Enter a valid email": "Anna kelvollinen sähköposti",
    "your@email.com": "sinun@email.com",

    // ---------- 404 ----------
    "Lost in the sauce": "Eksynyt kastikkeeseen",
    "This page doesn't exist — but the tacos do.":
      "Tätä sivua ei ole — mutta tacot ovat.",
    "Back home": "Takaisin etusivulle",
    "Something burned": "Jotain paloi",
    "Try refreshing or head back home.":
      "Yritä päivittää tai palaa etusivulle.",
    "Try again": "Yritä uudelleen",
  },
};
